module.exports = __webpack_public_path__ + "img/deviations-no-data.c989bcc2.png";